import script from "./LogsPeriod.vue?vue&type=script&setup=true&lang=js"
export * from "./LogsPeriod.vue?vue&type=script&setup=true&lang=js"

import "./LogsPeriod.vue?vue&type=style&index=0&id=0f59885c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f59885c"]])

export default __exports__